"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var url_helpers_1 = require("../shared/url_helpers");
var bind_1 = require("../../bind");
var api_request_1 = require("../api_request");
var classNames = require("classnames");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var WatchBadge = /** @class */ (function (_super) {
    tslib_1.__extends(WatchBadge, _super);
    function WatchBadge(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            watching: props.listing.watching,
        };
        return _this;
    }
    WatchBadge.prototype.watch = function () {
        var _this = this;
        api_request_1.V3.post(url_helpers_1.default.watchProductPath(this.props.listing.id))
            .fail(function () { return _this.setState({ watching: false }); });
        this.setState({ watching: true });
        this.trackClick('watch');
    };
    WatchBadge.prototype.unwatch = function () {
        var _this = this;
        api_request_1.V3.destroy(url_helpers_1.default.unwatchProductPath(this.props.listing.id))
            .fail(function () { return _this.setState({ watching: true }); });
        this.setState({ watching: false });
        this.trackClick('unwatch');
    };
    WatchBadge.prototype.trackClick = function (interactionType) {
        tracker_1.trackInteraction({
            interactionType: interactionType,
            componentName: 'WatchBadge',
            type: tracker_1.LISTING_TYPE,
            entityId: this.props.listing.id,
        });
    };
    WatchBadge.prototype.handleClick = function () {
        if (this.state.watching) {
            this.unwatch();
        }
        else {
            this.watch();
        }
    };
    WatchBadge.prototype.render = function () {
        var classes = classNames('watch-badge', { 'watch-badge--watching': this.state.watching });
        var title = this.state.watching ?
            I18n.t('discovery.watchBadge.unwatch') : I18n.t('discovery.watchBadge.watch');
        return (React.createElement("div", { className: classes },
            React.createElement("button", { onClick: this.handleClick, className: "watch-badge__button", title: title },
                React.createElement("span", { className: "watch-badge__icon" }))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], WatchBadge.prototype, "handleClick", null);
    return WatchBadge;
}(React.Component));
exports.default = WatchBadge;
//# sourceMappingURL=watch_badge.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/watch_badge.js
// module id = Jjo6
// module chunks = 20 21